import React from 'react';

import { Card } from '../Card';

import { AmericanMassageTherapyAssociationLogo } from './AmericanMassageTherapyAssociation';
import { NationalTechHonorSocietyLogo          } from './NationalTechHonorSociety';
import { SwedishInstitueLogo                   } from './SwidishInstitue';

const logoContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  marginTop: '50px'
};

const logoStyle = { 
  borderRadius: '5px',
  // display:'block',
  width: '150px' 
}

export function AllLogos(){
  return (
    <div style={logoContainerStyle}>
      <Card>
        <AmericanMassageTherapyAssociationLogo style={logoStyle} />
      </Card>
      <Card>
        <NationalTechHonorSocietyLogo style={logoStyle} />
      </Card>
      <Card>
        <SwedishInstitueLogo style={logoStyle} />
      </Card>
  </div> 
  );
}